import {IAlbumsStore} from './albums.interface';

export const albumsStoreInitialState: IAlbumsStore = {
  savedAlbumIds: [],
};
